import React, {ReactNode} from 'react';

import {LabelText, LabelContainer} from './styled';

interface Props {
    text?: string;
    hasError?: boolean;
    children: ReactNode;
    className?: string;
    isRequired?: boolean;
}

export function Label({text, hasError, children, className, isRequired = false}: Props) {
    return (
        <>
            {text ? (
                <LabelContainer className={className}>
                    <LabelText hasError={hasError} isRequired={isRequired}>
                        {text}
                    </LabelText>
                    {children}
                </LabelContainer>
            ) : (
                children
            )}
        </>
    );
}
